module.exports = __webpack_public_path__ + "static/media/images.05c67179.png";